<template>
  <div class="page coursework-item-page">
    <template v-if="backKey===true">
      <f7-navbar >
        <f7-nav-left style="padding-left:15px;">
           <i class="icon icon-back" @click="backIndex()" ></i>
        </f7-nav-left>
        <f7-nav-title>課輔媒合.</f7-nav-title>
      </f7-navbar>
    </template>
    <template v-else>
      <f7-navbar   >
        <div style="width:100%;text-align:center;">
          課輔媒合..
        </div>
      </f7-navbar>
    </template>
    <div class="page-content">
      <header class="wave-header sticky-top"></header>

      <p class="segmented segmented-round">
        <button
          :class="{'button':true,'button-round':true,'button-outline':true,'button-active':counselingActive}"
          @click="setTab('counseling')"
        >課輔中</button>
        <button
         :class="{'button':true,'button-round':true,'button-outline':true,'button-active':mergeActive}"
          @click="setTab('medium')"
        >媒合中</button>
        <button
         :class="{'button':true,'button-round':true,'button-outline':true,'button-active':historydActive}"
          @click="setTab('history')"
        >歷史紀錄</button>
      </p>

     <!--
    <template v-if="isloading">
      <counseling-item v-if="isTab.isCounseling"></counseling-item>
      <medium-item v-if="isTab.isMedium"></medium-item>
      <history-record v-if="isTab.isHistory"></history-record>
    </template>
-->
  <div id="counseling" v-if="counselingActive">
    
    <template v-if="!counselingLoading">
      <div class="list">
        <ul>
          <li v-for="(item,index) in supplementList">
            <div class="item-content" @click="checkHref('counseling-record',item.id,item.classImagePath,item.classHours,item.courseCode,item.applyStatus,item[matchNameKey],item.courseName,item.updatedAt,item.updatedBy,item[matchKey],item.courseEndAt)">
              <div 
                class="item-media list-avatar"
                >
                </div>
                <div class="item-inner">
                  <div class="item-title-row">
                    <div class="item-title">{{ item.courseName }}</div>
                  </div>
                  <div class="item-subtitle">{{ item[matchNameKey] }}</div>
                </div>
            </div>
            <br/>
          </li>
        </ul>
      </div>
      <template v-if="supplementList.length ==0">
        <div class="page-empty">
          <img src="../../images/background-img/study-grey.png" alt />
          <h3>目前尚無任何紀錄</h3>
        </div> 
      </template>
    </template>
    <template v-else>
      <div class="content-loading"></div>
    </template>
  </div>
    
  <div id="medium" v-if="mergeActive">
    <template v-if="!mergeLoading">
      <div class="list">
        <ul>
          <li v-for="(item,index) in matchList">
            <div class="item-content" @click="checkHrefMedium(item.id,item.setYear,item.setTerm,item.tutor,item.tutor,item.courseCode,item.courseName,item.applyStatus,item.courseEndAt,item.note,item.searchTerm,item.createdBy,item.createdAt,item.updatedBy,item.updatedAt)">
              <div
               class="item-media list-avatar"
              ></div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{ item.courseName }}</div>
                </div>
                <div class="item-subtitle">{{ item[matchNameKey] }}</div>
              </div>
            </div>
            <br/>
          </li>
        </ul>
      </div>
      <template v-if="matchList.length ==0">
        <div class="page-empty">
          <img src="../../images/background-img/study-grey.png" alt />
          <h3>目前尚無任何紀錄</h3>
        </div> 
      </template>
    </template>
    <template v-else>
      <div class="content-loading"></div>
    </template>
  </div>

          
      <div id="history" v-if="historydActive">
      <template v-if="!historydLoading">
        <div class="list">
          <template v-if="applyingFlag" >
            <section class="list media-list">
              <div class="block-header">申請中</div>
              <ul>
                <li v-for="(item,index) in historyList" v-if="item.applyStatus == 10" >
                  <div class="item-content">
                    <div 
                      class="item-media list-avatar"
                      ></div>
                      <div class="item-inner">
                        <div class="item-title-row">
                          <div class="item-title">{{ item.chinese }}</div>
                        </div>
                        <div class="item-subtitle">{{ item.courseName }}</div>
                      </div>
                  </div>
                  <br/>
                </li>
              </ul>
          </section>
        </template>
        <template v-if="classingFlag" >
          <section class="list media-list">
            <div class="block-header">課輔中</div>
            <ul>
              <li v-for="(item,index) in historyList" v-if="item.applyStatus == 30" >
                <div class="item-content">
                  <div 
                    class="item-media list-avatar"
                    ></div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">{{ item.chinese }}</div>
                      </div>
                      <div class="item-subtitle">{{ item.courseName }}</div>
                    </div>
                </div>
                <br/>
              </li>
            </ul>
          </section>
        </template>
        <template v-if="competeFlag" >
          <section class="list media-list">
            <div class="block-header">完成課輔</div>
            <ul>
              <li v-for="(item,index) in historyList" v-if="item.applyStatus == 60" >
                <div class="item-content">
                  <div 
                    class="item-media list-avatar"
                    ></div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">{{ item.chinese }}</div>
                      </div>
                      <div class="item-subtitle">{{ item.courseName }}</div>
                    </div>
                </div>
                <br/>
              </li>
            </ul>
          </section>
        </template>
        <template v-if="rejectFlag" >
          <section class="list media-list">
            <div class="block-header">拒絕申請</div>
            <ul>
              <li v-for="(item,index) in historyList" v-if="item.applyStatus == 80" >
                <div class="item-content">
                  <div 
                    class="item-media list-avatar"
                    ></div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">{{ item.chinese }}</div>
                      </div>
                      <div class="item-subtitle">{{ item.courseName }}</div>
                    </div>
                </div>
                <br/>
              </li>
            </ul>
          </section>
        </template>
      </div>

        </template>

    <template v-else>
      <div class="content-loading"></div>
    </template>
    </div>
    </div>
    <div class="fab fab-right-bottom">
      <a href="#">
        <i class="icon material-icons">add</i>
        <i class="icon material-icons">close</i>
      </a>
      <div class="fab-buttons fab-buttons-top">
        <template v-if="$store.state.coachType==10">
         <a href="/teaching1" class="fab-label">我的教課資訊</a>
        </template>
        <template v-else>
          <a href="/search" class="fab-label">申請輔導</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../../service";
import MediumItemPage from "./medium/medium-item.vue";
import CounselingItemPage from "./counseling/counseling-item.vue";
import HistoryRecordPage from "./counseling/history-record.vue";
import axios from '../../js/axiosModule';
import { bus } from '../../js/bus.js';
var moment = require('moment');
var moment2 = require('moment');
export default {
  components: {
   // "medium-item": MediumItemPage,
   // "counseling-item": CounselingItemPage,
   // "history-record": HistoryRecordPage
  },
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      isTab: {
        isCounseling: true,
        isMedium: false,
        isHistory: false
      },
      historydActive:false,
      counselingActive:false,
      mergeActive:false,
      historydLoading:false,
      counselingLoading:false,
      mergeLoading:false,
      supplementList:[],
      matchList:[],
      historyList:[],
      isloading:false,
      classImagePath:'',
      classHours:'',
      feedbackScore:'',
      feedbackNote:'',
      applyingFlag:false,
      classingFlag:false,
      competeFlag:false,
      rejectFlag:false,
      matchKey:this.$store.state.coachType==10 ? "tutee":"tutor",
      matchNameKey:this.$store.state.coachType==10 ? "tuteeName":"tutorName",
      tagUseNameKey:this.$store.state.coachType==10 ? "tuteeName":"tutorName",
      backKey:this.$f7route.query.back === undefined ? true : false
    };
  },
  methods: {
    setTab: function(model) {
      let self = this;
      this.clearTab();
      switch (model) {
        case "counseling":
          self.counselingActive= true;
          self.historydActive = false;
          self.mergeActive = false;
          this.isTab.isCounseling = true;
          break;
        case "medium":
          self.mergeActive=true;
          self.historydActive = false;
          self.counselingActive = false;
          this.isTab.isMedium = true;
          break;
        case "history":
          self.historydActive = true;
          self.counselingActive = false;
          self.mergeActive = false;
          this.isTab.isHistory = true;
          break;
        default:
          break;
      }
    },
    clearTab: function() {
      this.isTab.isCounseling = false;
      this.isTab.isMedium = false;
      this.isTab.isHistory = false;
    },
    getCourseWork : function() {     
      
      let self = this;
      if (window.localStorage.getItem("transferKey") !== undefined && window.localStorage.getItem("transferKey") === "mergeKey" ) {
          self.mergeActive = true;
        } else {
          self.counselingActive = true;
        }      
      self.historydLoading=true;
      self.counselingLoading=true;
      self.mergeLoading=true;
      var params = {};
      params.queryType= "studentno";
      params.queryString=self.$store.state.userInfo.studentNo.toUpperCase();
      params.minStatus = 10;
      params.maxStatus = 80;
      params.takeRowCount = 0;
      params.startAt = self.getHalfTime();
      params.endAt = self.getNowTime();
                console.log(params);

      var type10Number = 0;
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachApplyCoursesByStudentNo",params).then((response)=> {
        //self.isloading=true;

        console.log(response.data.data);

        var respData = response.data.data;        
        respData.forEach(function(item, index, arr) {
          var matchkey = "";
          console.log(self.$store.state.coachType);
          if (self.$store.state.coachType == 10 ) {
            matchkey = "tutorName";
          } else {
            matchkey = "tuteeName";
          }
          console.log(matchkey);
console.log(item[matchkey]);
           console.log(self.$store.state.userInfo.studentNo.toUpperCase());
          if (item[matchkey] === self.$store.state.userInfo.studentNo.toUpperCase()) {
            if (item.applyStatus == 30  && item.setYear == '114' && item.setTerm == '2' ) {

            //console.log(item.applyStatus);
           //  if (item.applyStatus == 30 ) {
              console.log("in30");
              self.supplementList.push(item);
              self.classingFlag=true;
            } else if(item.applyStatus == 10 ) {
              console.log("in10");
              type10Number++;
              self.applyingFlag = true;
              self.matchList.push(item);
            } else if (item.applyStatus == 60) {
              self.competeFlag = true;
            } else if (item.applyStatus == 80) {
              self.rejectFlag = true;
            }
            self.historyList.push(item);
          }
       //   self.isloading=false;
        });
        bus.$emit('mediumBus',{"matchList":self.matchList});
        bus.$emit('supplementBus',{"supplementList":self.supplementList});
        bus.$emit('historyList',{"historyList":self.historyList});
        console.dir(self.matchList);
        self.historydLoading=false;
        self.counselingLoading=false;
        self.mergeLoading=false;

        if (type10Number > 0 ) {
          this.setTab('medium');
        }
        
        
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    },
    checkHref: function(linkText,id,classImagePath,classHours,courseCode,applyStatus,chineseName,courseName,updatedAt,updatedBy,studentno,courseEndAt) {
      let self = this;

         
            var params = {};
            params.queryType="courseid";
            params.queryString = id;
            params.minStatus = applyStatus;
            params.maxStatus = applyStatus;
            params.takeRowCount= 0;
            params.startAt = self.getHalfTime();
            params.endAt = self.getNowTime();
            //console.dir(params);
            axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachClassRecords",params).then((response)=> {

                if (response.data.data.length > 0 ) {
                  var matchData = response.data.data[0];
                  self.feedbackScore = parseInt(response.data.data[0].feedbackScore)*2;
                  self.feedbackNote = response.data.data[0].feedbackNote;
                  self.classImagePath = response.data.data[0].classImagePath;
                  self.classHours = response.data.data[0].classHours;
                  self.$store.dispatch("feedBackSocreTrigger",matchData.feedbackScore);
                  window.localStorage.removeItem("classImagePathStr");
                  window.localStorage.removeItem("courseCodeStr");
                  window.localStorage.setItem("classImagePathStr",self.classImagePath);
                  window.localStorage.setItem("courseCodeStr",id);
                  return new Promise((resolve,reject) => {
                    this.$f7router.navigate("/" + linkText);
                    setTimeout(
                      function() {
                        
                        
                        bus.$emit("record-bus",{
                          "id":id,
                          "classImagePath":self.classImagePath,
                          "classHours":self.classHours,
                          "courseCode":courseCode,
                          "applyStatus":applyStatus,
                          "chineseName":chineseName,
                          "courseName":courseName,
                          "updatedAt":updatedAt,
                          "updatedBy":updatedBy,
                          "studentno":studentno,
                          "courseEndAt":courseEndAt,
                          "feedbackScore":self.feedbackScore,
                          "feedbackNote":self.feedbackNote});
                          
                          
                      }
                    ,100);
                  });
                } else {
                  self.feedbackScore = 0;
                  self.feedbackNote = '';
                  self.classImagePath = '';
                  self.classHours = 0;
                  self.$store.dispatch("feedBackSocreTrigger",0);
                  window.localStorage.removeItem("classImagePathStr");
                  window.localStorage.removeItem("courseCodeStr");
                  window.localStorage.setItem("classImagePathStr",'');
                  window.localStorage.setItem("courseCodeStr",id);
                  return new Promise((resolve,reject) => {
                    this.$f7router.navigate("/" + linkText);
                    setTimeout(
                      function() {
                        
                        
                        bus.$emit("record-bus",{
                          "id":id,
                          "classImagePath":self.classImagePath,
                          "classHours":self.classHours,
                          "courseCode":courseCode,
                          "applyStatus":applyStatus,
                          "chineseName":chineseName,
                          "courseName":courseName,
                          "updatedAt":updatedAt,
                          "updatedBy":updatedBy,
                          "studentno":studentno,
                          "courseEndAt":courseEndAt,
                          "feedbackScore":self.feedbackScore,
                          "feedbackNote":self.feedbackNote});
                          
                          
                      }
                    ,100);
                  });
                }
                
                
              
              
            }).catch(err=>function() {
              if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
                self.$f7router.navigate("/login");
              } 
            });
     
    
    },
     getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    //  var dateTime = new Date(date+'T'+time);
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    },
    getHalfTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      //var dateTime = new Date(date+'T'+time);
      //console.dir(moment(date+' '+time,"YYYY-MM-DD HH:mm:ss").month(1));
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss").month(-6)._d;
      
      return dateTime;
    },
    backIndex:function() {
      this.$f7router.navigate("/" );
    },
    checkHrefMedium: function(id,setYear,setTerm,tutor,tutee,courseCode,courseName,applyStatus,courseEndAt,note,searchTerm,createdBy,createdAt,updatedBy,updatedAt) {
      let self=this;

      
      if ( self.$store.state.coachType == 10 ) {
        return new Promise((resolve,reject) => {
          self.$f7router.navigate("/medium-detail-teacher" );
            setTimeout(
              function() {
                bus.$emit("detail-teacher",{
                    "id":id,
                    "setYear":setYear,
                    "setTerm":setTerm,
                    "tutor":tutor,
                    "tutee":tutee,
                    "courseCode":courseCode,
                    "courseName":courseName,
                    "applyStatus":applyStatus,
                    "courseEndAt":courseEndAt,
                    "note":note,
                    "searchTerm":searchTerm,
                    "createdBy":createdBy,
                    "createdAt":createdAt,
                    "updatedBy":updatedBy,
                    "updatedAt":updatedAt});
              }
            ,100);
          });
      
      } else if ( self.$store.state.coachType == 20 ) {
        return new Promise((resolve,reject) => {
          self.$f7router.navigate("/medium-detail-student" );
            setTimeout(
              function() {
                bus.$emit("detail-student",{
                   "id":id,
                    "setYear":setYear,
                    "setTerm":setTerm,
                    "tutor":tutor,
                    "tutee":tutee,
                    "courseCode":courseCode,
                    "courseName":courseName,
                    "applyStatus":applyStatus,
                    "courseEndAt":courseEndAt,
                    "note":note,
                    "searchTerm":searchTerm,
                    "createdBy":createdBy,
                    "createdAt":createdAt,
                    "updatedBy":updatedBy,
                    "updatedAt":updatedAt});
              }
            ,100);
          });
      }
      

      
    }
  },mounted() {
    let self = this;
    self.getCourseWork();
  },created() {
    this.$store.dispatch('backTrigger',this.backKey);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/coursework-item.vue